import {GroupZoneType} from '../../form-generator/form-generator.interfaces';

export interface ContractData {
  id?: number;
  contractId?: number;
  dated?: boolean;
  beginDate?: string;
  endDate?: string;
  updateDate?: string;
  values?: { [key: string]: ValueData };
  groupZoneType?: GroupZoneType;
  groupName?: string;
  groupZoneKeyName?: string;
}

export interface ValueData {
  value: any;
  type: ZoneType | string;
  transId?: string;
}

export enum ProfileType {
  ESS = 'ESS',
  MSS = 'MSS'
}

export enum ZoneType {
  ENTITY = 'ENTITY',
  ENTITY_DATA = 'ENTITY_DATA',
  ENTITY_PREFIXED = 'ENTITY_PREFIXED',
  CONTRACT = 'CONTRACT',
  BOOLEAN = 'BOOLEAN',
  PEOPLE_TREE = 'PEOPLE_TREE',
  ID = 'ID',
  PERCENTAGE = 'PERCENTAGE',
  DECIMAL = 'DECIMAL',
  INTEGER = 'INTEGER',
  CURRENCY = 'CURRENCY',
  LABEL = 'LABEL',
  AUTO_GENERATED = 'AUTO_GENERATED',
  LIST = 'LIST',
  TREE = 'TREE',
  GLO_LIST = 'GLO_LIST',
  TEXT = 'TEXT',
  DATE = 'DATE',
  GRAPH_MONTH = 'GRAPH_MONTH',
  FILE = 'FILE',
  FILES = 'FILES',
  CLI_REG = 'CLI_REG',
  EMPTY = 'EMPTY',
  OTHER = 'OTHER',
  WORK_CYCLE_TABLE = 'WORK_CYCLE_TABLE',
  ACTIVE_EMPLOYEE = 'ACTIVE_EMPLOYEE',
  ACCOUNTING_ZONE = 'ACCOUNTING_ZONE',
  BLANK = 'BLANK',
  BREAK_LINE = 'BREAK_LINE'
}

export enum ContractStatus {
  INITIATED = 'INITIATED',
  TO_BE_FINALIZED = 'TO_BE_FINALIZED',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  FUTURE = 'FUTURE'
}

export enum SdcSyncStatus {
  COMPLIANT = 'OK',
  SUCCESS = 'COMPLETE',
  FAILED = 'FAILED',
  IN_PROGRESS = 'PENDING',
  BLOCKED = 'BLOCKED'
}
